import { BaseService } from '../common/service/base.service';

export class BaseLandscapeService extends BaseService {
  constructor(apiVersion: string = 'v1') {
    super(process.env.REACT_APP_LANDSCAPE_API_URL || '', apiVersion);
  }
}
